import { useEffect } from 'react';
import { shape, string } from 'prop-types';
import { Heading, LabelText } from 'shared/components';
import { InputsContainer } from 'shared/containers';
import { SelectField, RadioSwitchFields } from 'shared/fields';
import { shapeSettings } from '../../config';
import { useNavigate } from 'react-router-dom';

const MortgageProvider = ({
    settings: { meta: { mortgage_providers } },
    values: { mortgage_provider },
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/hypotheekbespaarcheck/mortgage-provider');
  }, [navigate]);

  const labelsOfProvider =
    (mortgage_providers.find(provider => provider.value === mortgage_provider) || {}).labels;

  return (
    <>
      <Heading>Geldverstrekker</Heading>
      <InputsContainer>
        <LabelText>Bij welke bank heb jij je hypotheek afgesloten?</LabelText>
        <SelectField
          id="mortgage_provider"
          name="mortgage_provider"
          options={mortgage_providers || []}
          placeholder="Selecteer een geldverstrekker"
        />
        <LabelText>Hoe heet het hypotheekproduct dat bij je hypotheek hoort?</LabelText>
        <SelectField
          id="product_line"
          name="product_line"
          options={labelsOfProvider || []}
          noOptionsMessage={() => 'Selecteer eerst een geldverstrekker'}
          placeholder="Selecteer een naam"
        />
        <LabelText>Heb je een hypotheek met Nationale Hypotheek Garantie (NHG)</LabelText>
        <RadioSwitchFields name="nhg" />
      </InputsContainer>
    </>
  );
};

MortgageProvider.propTypes = {
  settings: shapeSettings.isRequired,
  values: shape({
    mortgage_provider: string,
  }).isRequired,
};

export default MortgageProvider;
